<app-header></app-header>
<app-menu></app-menu>
<div
  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
  style="padding-top: 80px"
  
>
  <mat-tab-group
    mat-align-tabs="center"
    [selectedIndex]="indexTabs.value"
    (selectedIndexChange)="indexTabs.setValue($event)"
  >
    <mat-tab label="Receive products">
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
        style="margin-top: 20px; height: 500px"
      >
        <div
          class="
				col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
				row
			  " applytabindexes
          [formGroup]="FormReceivingProducts"
        >
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
		  row"
          >
            <div
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
              style="
			  margin-top: 1.4vh;
		  "
            >
              <mat-form-field appearance="fill" class="InputSty">
                <mat-label>Select customer</mat-label>
                <mat-select
                  formControlName="customer"
                  class="TabOnEnterReceiving"
                  tabindex="1"
                  (ngModelChange)="OnSelectProductsItems()"
                >
                  <mat-option
                    *ngFor="let item of PlaceOrderCustomer"
                    [value]="item.key"
                    >{{ item.value }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
            <div
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
              style="
    margin-top: 1.4vh;
"
            >
              <mat-form-field class="InputSty" appearance="fill">
                <mat-label>Reference #</mat-label>
                <input matInput type="text" formControlName="referencia" class="TabOnEnterReceiving" tabindex="2"/>
              </mat-form-field>
            </div>
            <div
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
            >
              <mat-form-field
                color="accent"
                appearance="fill"
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty"
              >
                <mat-label>ETA</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker3"
                  formControlName="eta"
                  class="TabOnEnterReceiving"
                  tabindex="3"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker3"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker3></mat-datepicker>
              </mat-form-field>
            </div>
            <div
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
            >
              <mat-form-field
                color="accent"
                appearance="fill"
                class="col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8 InputSty"
              >
                <mat-label>Received date</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker4"
                  formControlName="receivingdate"
                  class="TabOnEnterReceiving"
                  tabindex="4"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker4"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker4 color="primary"></mat-datepicker>
              </mat-form-field>
            </div>
            <div
              class="
				  col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4
				  row InputSty
				"
            >
              <p
                class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty TabOnEnterReceiving" tabindex="5"
              >
                <mat-checkbox formControlName="Billed" tabindex="5"
                  ><span
                    ><br />
                    Billed</span
                  ></mat-checkbox
                >
              </p>

              <p
                class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 InputSty TabOnEnterReceiving"  tabindex="6"
              >
                <mat-checkbox formControlName="HandlingCharge" tabindex="6"
                  ><span
                    >Handling <br />
                    Charge</span
                  ></mat-checkbox
                >
              </p>
              <p
                class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 InputSty TabOnEnterReceiving"
                tabindex="7"
                >
                <mat-checkbox formControlName="ShortTermStorage" tabindex="7"
                
                  ><span
                    >Short Term <br />
                    Storage</span
                  ></mat-checkbox
                >
              </p>
            </div>

            <h4
              class="
				  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
				"
              style="height: 3vh"
            >
              Receiving details
            </h4>
            <div
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
            >
              <mat-form-field
                class="example-full-width InputSty"
                appearance="fill"
              >
                <mat-label>Carrier</mat-label>
                <input matInput formControlName="Carrier" class="TabOnEnterReceiving" tabindex="8"/>
              </mat-form-field>
            </div>
            <div
              class="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 col-xxl-1 InputSty"
            >
              <mat-form-field
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty"
                appearance="fill"
              >
                <mat-label>BOL #</mat-label>
                <input matInput formControlName="bol" class="TabOnEnterReceiving" tabindex="9" />
              </mat-form-field>
            </div>
            <div
              class="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 col-xxl-1 InputSty"
            >
              <mat-form-field
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty"
                appearance="fill"
              >
                <mat-label>PO #</mat-label>
                <input matInput formControlName="po" class="TabOnEnterReceiving" tabindex="10"/>
              </mat-form-field>
            </div>
            <div
              class="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 col-xxl-1 InputSty"
            >
              <mat-form-field
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty"
                appearance="fill"
              >
                <mat-label>Misc</mat-label>
                <input matInput formControlName="misc" class="TabOnEnterReceiving" tabindex="11" />
              </mat-form-field>
            </div>
            <div
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
            >
              <mat-form-field
                class="example-full-width InputSty"
                appearance="fill"
              >
                <mat-label>Container/Trailer</mat-label>
                <input matInput formControlName="container" class="TabOnEnterReceiving" tabindex="12" />
              </mat-form-field>
            </div>
            <div
              class="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 col-xxl-1 InputSty"
            >
              <mat-form-field
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty"
                appearance="fill"
              >
                <mat-label>Seal #</mat-label>
                <input matInput formControlName="seal"  class="TabOnEnterReceiving" tabindex="13"/>
              </mat-form-field>
            </div>
            <div
              class="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 col-xxl-1 InputSty"
            >
              <mat-form-field
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty"
                appearance="fill"
              >
                <mat-label>Door #</mat-label>
                <input matInput formControlName="door" class="TabOnEnterReceiving" tabindex="14"/>
              </mat-form-field>
            </div>
            <div
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
            >
              <mat-form-field appearance="fill" class="InputSty TabOnEnterReceiving" tabindex="15">
                <mat-label>Select capacity</mat-label>
                <mat-select formControlName="capacity" class="" >
                  <mat-option value="0">None</mat-option>
                  <mat-option value="1">20' Container</mat-option>
                  <mat-option value="2">40' Container</mat-option>
                  <mat-option value="3">45' HC Container</mat-option>
                  <mat-option value="4">48' Trailer</mat-option>
                  <mat-option value="5">53' Trailer</mat-option>
                  <mat-option value="6">Bobtail</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div
              *ngIf="false"
              class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              style="margin-top: 15px"
            >
              <mat-form-field class="example-full-width" >
                <mat-label>Total pallets #</mat-label>
                <input matInput type="number" formControlName="pallets" />
              </mat-form-field>
            </div>
            <div
              class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 InputSty"
              style="margin-top: 15px"
            >

              <mat-form-field appearance="fill" class="TabOnEnterReceiving" tabindex="16">
                <mat-label>Select Status.</mat-label>
                <mat-select formControlName="status" >
                  <mat-option value=""
                  >-------</mat-option
                >
                  <mat-option value="READY FOR PICKUP AT CONTAINER/CFS TERMINAL"
                    >READY FOR PICKUP AT CONTAINER/CFS TERMINAL</mat-option
                  >
                  <mat-option value="PENDING RELEASE AT CONTAINER/CFS TERMINAL"
                    >PENDING RELEASE AT CONTAINER/CFS TERMINAL</mat-option
                  >
                  <mat-option value="PENDING ARRIVAL AT CONTAINER/CFS TERMINAL"
                    >PENDING ARRIVAL AT CONTAINER/CFS TERMINAL</mat-option
                  >
                  <mat-option value="SHIPMENT CANCELLED"
                    >SHIPMENT CANCELLED</mat-option
                  >
                  <mat-option value="DELIVERED/COMPLETE"
                    >DELIVERED/COMPLETE</mat-option
                  >
                  <mat-option value="(ON HOLD) PROBLEM WITH SHIPMENT"
                    >(ON HOLD) PROBLEM WITH SHIPMENT</mat-option
                  >

                  <mat-option value="FREIGHT PENDING CHECKIN ON DOCK"
                    >FREIGHT PENDING CHECKIN ON DOCK</mat-option
                  >
                  <mat-option value="RECOVERED AND IN TRANSIT TO DESTINATION"
                    >RECOVERED AND IN TRANSIT TO DESTINATION</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>

            <!-- <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
			  <mat-form-field class="example-full-width">
				<mat-label>Vassel name</mat-label>
				<input matInput />
			  </mat-form-field>
			</div>
			<div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
			  <mat-form-field class="example-full-width">
				<mat-label>Booking#</mat-label>
				<input matInput />
			  </mat-form-field>
			</div>
			<div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
			  <mat-form-field class="example-full-width">
				<mat-label>Cut off</mat-label>
				<input matInput />
			  </mat-form-field>
			</div>
			<div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
			  <mat-form-field class="example-full-width">
				<mat-label>ETD</mat-label>
				<input matInput />
			  </mat-form-field>
			</div> -->
            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
              <mat-form-field class="example-full-width">
                <mat-label>Notes</mat-label>
                <textarea
                  matInput
                  placeholder="Notes"
                  formControlName="notes"
                  class="TabOnEnterReceiving" tabindex="17"
                ></textarea>
              </mat-form-field>
            </div>

            <div
              class="
				  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
				"
              style="text-align: center"
            >
              <button
                style="width: 180px"
                mat-raised-button
                color="danger"
                class="
					col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
				  "
                (click)="OnCancelarEdicion()"
                type="button"
              >
               New order
              </button>
              <button
              type="button"
                style="width: 120px"
                mat-raised-button
                color="primary"
                class="
					col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
				  "
                (click)="OnSaveOrUpdate()"
              >
                {{buttonEditaLabel}}
              </button>
              <button
                style="width: 120px;"
                *ngIf="!productosTab"
                mat-raised-button
                color="success"
                type="button"
                class="
						  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
						"
                (click)="OnCancelarEdicion()"
              >
                Complete
              </button>
            </div>
          </div>
        </div>
        <div
          class=" col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12  row"
        >
          <div
            *ngIf="!productosTab"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
          >
            <div
              class="
				col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
				row
			  " applytabindexes
              [formGroup]="FormReceivingProductsAdd"
              style="margin-top: 30px; height: auto"
              
            >
              <div
                class="
				  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
				"
              >
                <h3 style="text-align: center">Total items: {{ piezas }}</h3>
              </div>

              <div
                style="
			  height: 16vh !important;
		  "
                class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 col-xxl-5 InputSty"
              >
                <div
                  class="
				col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
				row InputSty
			  "
                  style="padding-left: 30px"
                >
                  <button
                    mat-raised-button
                    color="primary"
                    class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
                    style="bottom: 7px;height: 5vh !important;"
                    (click)="OnSelectProductsItems()"
                  >
                    Clear
                  </button>
                  <mat-slide-toggle
                    [checked]="checked2"
                    (click)="ModalProducts()"
                    class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
                  >
                    New product
                  </mat-slide-toggle>
                </div>
                <mat-form-field
                  appearance="fill"
                  class="
					col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty
				  "
                >
                  <mat-label>Products</mat-label>
                  <input
                    type="text"
                    matInput
                    [formControl]="myControl"
                    [matAutocomplete]="auto"
                    id="product"
                    class="product enterProductAdd"
                    (keydown.@)="onKeydown($event)"
                    tabindex="18"
                  />
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    [displayWith]="displayFn"
                  >
                    <mat-option
                      *ngFor="let option of filteredOptions | async"
                      [value]="option"
                    >
                      {{ "Product: " + option.ItemNumber + ", Description: " +
                      option.ItemDescription }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div
                class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
                style="margin-top: 6vh !important"
              >
                <mat-form-field appearance="fill" class="enterProductAdd">
                  <mat-label>Select an type</mat-label>
                  <mat-select formControlName="type" tabindex="19" class="enterProductAdd">
                    <mat-option value="PLTS">PLTS</mat-option>
                    <mat-option value="CTNS">CTNS</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div
                class="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 col-xxl-1"
                style="margin-top: 8vh !important;"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Quantity #</mat-label>
                  <input
                  class="enterProductAdd"
                  tabindex="20"
                    matInput
                    type="number"
                    formControlName="Quantity"
                    (ngModelChange)="OnMultiplicarPalletes($event)"
                    (keypress)="OnMultiplicarPalletes($event)"
                    (click)="OnMultiplicarPalletes($event)"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 col-xxl-1 InputSty"
                *ngIf="true"
                style="margin-top: 8vh !important;"
              >
                <mat-form-field
                  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty"
                  appearance="fill"
                >
                  <mat-label>Pallets x^?</mat-label>
                  <input
                  class="enterProductAdd"
                  tabindex="21"
                    matInput
                    type="number"
                    formControlName="palletsx"
                    (ngModelChange)="OnMultiplicarPalletes($event)"
                    (keypress)="OnMultiplicarPalletes($event)"
                    (click)="OnMultiplicarPalletes($event)"
                  />
                </mat-form-field>
              </div>
              <div
                *ngIf="false"
                class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Lot #</mat-label>
                  <input matInput formControlName="Lot" />
                </mat-form-field>
              </div>
              <div
                *ngIf="false"
                class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
                style="margin-top: 12px; left: 14px"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>Serial #</mat-label>
                  <input matInput formControlName="Serial" />
                </mat-form-field>
              </div>
              <div
                class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
                style="margin-top: 8vh !important"
              >
                <mat-form-field class="example-full-width">
                  <mat-label>weight</mat-label>
                  <input matInput formControlName="weight" type="number" tabindex="22" class="enterProductAdd"/>
                </mat-form-field>
              </div>
              <div
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              style="margin-top: 1.5vh !important;"
            >
            <mat-form-field  appearance="fill"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty">
              <mat-label>Search Location</mat-label>
              <input matInput (keyup)="applyFilterLocation($event)" #input />
             
              <mat-hint>Filter Location</mat-hint>
            </mat-form-field>
           </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 InputSty"
                style="margin-top: 2vh !important;"
              >
                <mat-form-field
                  appearance="fill"
                  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty"
                >
                  <mat-label>Location</mat-label>
                  <mat-select formControlName="location" tabindex="23" class="enterProductAdd" #locations>
                    <mat-option
                      *ngFor="let item of ArrayLocations"
                      [value]="item.id"
                      >Location: {{ item.location }} - Description: {{ item.locationDescription }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>

              <div
                *ngIf="false"
                class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
              >
                <mat-form-field color="accent" appearance="fill">
                  <mat-label>Expiration date</mat-label>
                  <input
                    matInput
                    [matDatepicker]="pickerProductEter"
                    formControlName="pickerProductEter"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="pickerProductEter"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #pickerProductEter></mat-datepicker>
                </mat-form-field>
              </div>
              <div
                class="
				  col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 InputSty
				"
              >
                <mat-form-field
                  appearance="fill"
                  class="
					col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty
				  "
                >
                  <mat-label>Note</mat-label>
                  <textarea matInput formControlName="Note" tabindex="24" class="enterProductAdd"></textarea>
                </mat-form-field>
              </div>
              <div
                class="
				  col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2
				  row InputSty
				"
                style="margin-top: 16px;text-align: right !important;"
              >
                <div
                  class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                >
                  <button
                    mat-raised-button
                    color="primary"
                    (click)="OnNewOrEditProdutsLsit()"
                  >
                    Add product
                  </button>
                 
                
                </div>
                
                <div
                  *ngIf="false"
                  class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                >
                  <button
                    *ngIf="false"
                    mat-raised-button
                    color="success"
                    class="
					  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
					"
                    (click)="OnCancelarEdicion()"
                  >
                    Complete
                  </button>
                </div>
              </div>
            </div>
            <div
              class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
              *ngIf="viewEdit"
              style="margin-top: 20px"
            >
              <mat-form-field appearance="outline">
                <mat-label>Search</mat-label>
                <input
                  matInput
                  (keyup)="applyFilter2($event)"
                  placeholder="search"
                  #inputReceivingedit
                />
                <button
                  mat-button
                  (click)="openDialogLectorGeneral(5)"
                  matSuffix
                  mat-icon-button
                  color="primary"
                  aria-label="Example icon button with a menu icon"
                >
                  <mat-icon>qr_code_scanner</mat-icon>
                </button>
                <mat-hint>Filter table</mat-hint>
              </mat-form-field>
              <div
                class="
				  example-container
				  mat-elevation-z8
				  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
				"
              >
            
              <div class="example-loading-shade"
              *ngIf="isLoadingResults2 || isRateLimitReached2">
           <mat-spinner *ngIf="isLoadingResults2" #itemsRece></mat-spinner>
           <div class="example-rate-limit-reached" *ngIf="isRateLimitReached2">
             Load
           </div>
         </div>

                <div class="example-table-container" *ngIf="viewproducts">
                  <table
                    mat-table
                    [dataSource]="dataReceivingEdit"
                    matSort
                    #receivingeditSort="matSort"
                    class="example-table"
                  >
                    <!-- Number Column -->
                    <ng-container matColumnDef="id" sticky>
                      <th mat-header-cell *matHeaderCellDef>Options</th>
                      <td mat-cell *matCellDef="let row">
                        <button
                        mat-icon-button
                        [matMenuTriggerFor]="menupp"
                        aria-label="Example icon-button with a menu"
                      >
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #menupp="matMenu">
                        <button
                          mat-menu-item
                          color="primary"
                          style="width: 87px; height: 43px"
                          (click)="OnProductEditar(row)"
                          *ngIf="!editItemsReceive"
                        >
                          Edit
                        </button>
                        <button
                          mat-menu-item
                          color="danger"
                          style="width: 87px; height: 43px"
                          (click)="OnDeleteProductAdd(row)"
                        >
                          Delete
                        </button>
                      </mat-menu>
                      </td>
                    </ng-container>

                    <!-- ItemNumber Column -->
                    <ng-container matColumnDef="ItemNumber">
                      <th mat-header-cell *matHeaderCellDef>
                        <div class="theadTable">Item number</div>
                      </th>
                      <td mat-cell *matCellDef="let row">
                        <div class="theadTable">
                          {{ row.ItemNumber }}
                        </div>
                      </td>
                    </ng-container>

                    <!-- ItemDescription Column -->
                    <ng-container matColumnDef="ItemDescription">
                      <th mat-header-cell *matHeaderCellDef>
                        <div class="theadTable">Description</div>
                      </th>
                      <td mat-cell *matCellDef="let row">
                        <div class="theadTable">
                          {{ row.ItemDescription }}
                        </div>
                      </td>
                    </ng-container>

                    <!-- LotNumber Column -->
                    <ng-container matColumnDef="LotNumber">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                        disableClear
                      >
                        <div class="theadTable">Lot #</div>
                      </th>
                      <td mat-cell *matCellDef="let row">
                        <div class="theadTable">{{ row.LotNumber }}</div>
                      </td>
                    </ng-container>
                    <!-- StatedQuantity Column -->
                    <ng-container matColumnDef="StatedQuantity">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                        disableClear
                      >
                        Quantity
                      </th>
                      <td mat-cell *matCellDef="let row">
                        {{ row.StatedQuantity }}
                      </td>
                    </ng-container>
                    <!-- Location Column -->
                    <ng-container matColumnDef="Location">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                        disableClear
                      >
                        <div class="theadTable">Location</div>
                      </th>
                      <td mat-cell *matCellDef="let row">
                        <div class="theadTable">{{ row.Location }}</div>
                      </td>
                    </ng-container>
                    <!-- LocationID Column -->
                    <ng-container matColumnDef="LocationID">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                        disableClear
                      >
                        <div class="theadTable">Location #</div>
                      </th>
                      <td mat-cell *matCellDef="let row">
                        <div class="theadTable">{{ row.LocationID }}</div>
                      </td>
                    </ng-container>
                    <!-- SerialNumber Column -->
                    <ng-container matColumnDef="SerialNumber">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                        disableClear
                      >
                        <div class="theadTable">Serial #</div>
                      </th>
                      <td mat-cell *matCellDef="let row">
                        <div class="theadTable">{{ row.SerialNumber }}</div>
                      </td>
                    </ng-container>
                    <!-- ExpirationDate Column -->
                    <ng-container matColumnDef="ExpirationDate">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                        disableClear
                      >
                        <div class="theadTable">Exp._Date</div>
                      </th>
                      <td mat-cell *matCellDef="let row">
                        <div class="theadTable">{{ row.ExpirationDate }}</div>
                      </td>
                    </ng-container>
                    <!-- ItemValue Column -->
                    <ng-container matColumnDef="ItemValue">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                        disableClear
                      >
                        Value
                      </th>
                      <td mat-cell *matCellDef="let row">
                        {{ row.ItemValue }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="Note">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                        disableClear
                      >
                        Note
                      </th>
                      <td mat-cell *matCellDef="let row">
                        <p>
                          <span>{{ row.Note }}</span>
                        </p>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="weight_pllets">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                        disableClear
                      >
                        Weight
                      </th>
                      <td mat-cell *matCellDef="let row">
                        <p>
                          <span>{{ row.weight_pllets }}</span>
                        </p>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="type_pallets" stickyEnd>
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header
                        disableClear
                      >
                        Type
                      </th>
                      <td mat-cell *matCellDef="let row">
                        <p>
                          <span>{{ row.type_pallets }}</span>
                        </p>
                      </td>
                    </ng-container>

                    <tr
                      mat-header-row
                      *matHeaderRowDef="displayedColumnsReceivingEditaTable"
                    ></tr>
                    <tr
                      mat-row
                      *matRowDef="
						let row;
						columns: displayedColumnsReceivingEditaTable
					  "
                    ></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                      <td class="mat-cell" colspan="4">
                        No data matching the filter "{{ inputReceivingedit.value
                        }}"
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

              <mat-paginator
                [pageSizeOptions]="[50, 100, 250, 1000,10000]"
                matPaginator
                [pageSize]="1000"
                [length]="resultsLengthProduct"
                #receivingeditPaginator="matPaginator"
              ></mat-paginator>
            </div>
          </div>
         
          <div
          class=" col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          style="
height: 40vh !important;
overflow: scroll;margin-top: 2vh;
"
        >
          <button
            mat-raised-button
            color="primary"
            class="printPageButton"
            (click)="onSelectSummaryProducts()"
          >
            Refresh
          </button>
          <table
            class="table table-bordered"
            
            style="width: 100% !important"
          >
            <thead>
              <tr>
               
                <th>Item Number</th>
                <th>Description</th>
                <th>Pallet</th>
                <th>Per Pallet Qty</th>
                <th>Total</th>
             
               
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of summaryProducts; let i=index">
               
                <td>{{item.itemNumber}}</td>
                <td>{{item.description}}</td>
                <td>{{item.pallets}}</td>
                <td>{{item.perPalletQty}}</td>
                <td>{{item.total}}</td>
                
              </tr>
            </tbody>
          </table>
        </div>




          <div
            *ngIf="!productosChangeTab"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
          >
            <div class="col-md-12">
              <div
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
              ></div>
              <h2 class="col-md-12" style="text-align: center">
                Company charges item-%{{ descuentoCharges }}
              </h2>

<div  [formGroup]="FormInvoiceHeader" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row">
  <div
 
  class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
>
  <mat-form-field class="example-full-width">
    <mat-label>From name</mat-label>
    <input matInput formControlName="fromname" />
  </mat-form-field>
</div>

<div
 
class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
>
<mat-form-field class="example-full-width">
  <mat-label>From street</mat-label>
  <input matInput  formControlName="fromstreet"/>
</mat-form-field>
</div>


<div
 
class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
>
<mat-form-field class="example-full-width">
  <mat-label>To name</mat-label>
  <input matInput formControlName="toname" />
</mat-form-field>
</div>
<div
 
class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
>
<mat-form-field class="example-full-width">
  <mat-label>To street</mat-label>
  <input matInput  formControlName="tostreet"/>
</mat-form-field>
</div>
<div
 
class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
>
<mat-form-field class="example-full-width">
  <mat-label>Bill name</mat-label>
  <input matInput formControlName="billname" />
</mat-form-field>
</div>
<div
 
class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
>
<mat-form-field class="example-full-width">
  <mat-label>Bill street</mat-label>
  <input matInput formControlName="billstreet" />
</mat-form-field>
</div>
<div
 
class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
>
<mat-form-field class="example-full-width">
  <mat-label>Invoice#</mat-label>
  <input matInput  formControlName="invoicenumber"/>
</mat-form-field>
</div>
<div
 
class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
>
<mat-form-field class="example-full-width">
  <mat-label>Pay termi.</mat-label>
  <input matInput formControlName="payterm" />
</mat-form-field>
</div>
<div
 
class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
>
<mat-form-field class="example-full-width">
  <mat-label>CustomerID</mat-label>
  <input matInput formControlName="customerid"  />
</mat-form-field>
</div>
<div
 
class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
>
<mat-form-field class="example-full-width">
  <mat-label>Reference#</mat-label>
  <input matInput formControlName="referencesnumber"  />
</mat-form-field>
</div>
<div
class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
>
<mat-form-field color="accent" appearance="fill" class="InputSty">
  <mat-label>Date</mat-label>
  <input matInput [matDatepicker]="picker1DateInvoice"  formControlName="dateinvoice"/>
  <mat-datepicker-toggle
    matSuffix
    [for]="picker1DateInvoice"
  ></mat-datepicker-toggle>
  <mat-datepicker #picker1DateInvoice></mat-datepicker>
</mat-form-field>
</div>
<div
 
class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
>
<mat-form-field class="example-full-width">
  <mat-label>Total amount</mat-label>
  <input matInput formControlName="totalamount"  />
</mat-form-field>
</div>
<div
class="
col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 InputSty
"
>
<mat-form-field
  appearance="fill"
  class="
col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty
"
>
  <mat-label>Note</mat-label>
  <textarea matInput formControlName="noteinvoice"></textarea>
</mat-form-field>
</div>

<button
mat-raised-button
color="primary"
class="col-md-2 InputSty"
(click)="OnInvoiceHeaderInsert()"
>
{{labelInvoiceHeaderButton}}
</button>

</div>

              <div
                class="
					  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
					  row
					"
                style="margin-top: 20px"
                [formGroup]="FormReceivingChanges"
              >
                <p
                  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
                >
                  <mat-checkbox
                    [(ngModel)]="AllChargesAdded"
                    [checked]="AllChargesAdded"
                    (change)="onCheckAllCharges($event)"
                    >AllChargesAdded</mat-checkbox
                  >
                </p>

                <mat-form-field appearance="fill" class="col-md-5 InputSty">
                  <mat-label>Select</mat-label>
                  <mat-select
                    formControlName="invoiceListSelect"
                    (selectionChange)="OnCustomerChargesDesc($event)"
                  >
                    <mat-option
                      *ngFor="let topping of invoiceList"
                      [value]="topping"
                      >{{ topping.value }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="col-md-2 InputSty">
                  <mat-label>Unit price</mat-label>
                  <input
                    matInput
                    placeholder="Unit price"
                    formControlName="priceUnit"
                    (change)="OnOperacion()"
                  />
                </mat-form-field>
                <mat-form-field appearance="fill" class="col-md-2 InputSty">
                  <mat-label>Quantity</mat-label>
                  <input
                    matInput
                    placeholder="Quantity"
                    formControlName="QuantityChanges"
                    (change)="OnOperacion()"
                  />
                </mat-form-field>
                <mat-form-field appearance="fill" class="col-md-2 InputSty">
                  <mat-label>Total</mat-label>
                  <input
                    matInput
                    placeholder="Total"
                    formControlName="TotalChangesR"
                  />
                </mat-form-field>

                <div class="col-md-12 btn-group">
                  <button
                    mat-raised-button
                    color="danger"
                    class="col-md-6 InputSty"
                    (click)="OnClearReceivingCharges()"
                  >
                    Cancel
                  </button>

                  <button
                    mat-raised-button
                    color="primary"
                    class="col-md-6 InputSty"
                    (click)="OnNewChanges()"
                  >
                    Add
                  </button>
                </div>
              </div>

              <div class="col-md-12" style="margin-top: 5px">
                <mat-form-field appearance="standard">
                  <mat-label>Search</mat-label>
                  <input
                    matInput
                    (keyup)="applyFilterChangesReceivig($event)"
                    placeholder="Search"
                    #inputChangeReceiving
                  />
                </mat-form-field>

                <div
                  class="
					example-container
					mat-elevation-z8
					col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
                >
                  <div class="example-table-container">
                    <table
                      mat-table
                      [dataSource]="dataSourceChangesReceivig"
                      matSort
                      #ChangeReceivinngsortSearch="matSort"
                      class="example-table"
                    >
                      <!-- ID Column -->
                      <ng-container matColumnDef="Id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          Options
                        </th>
                        <td mat-cell *matCellDef="let row">
                          <button
                            mat-icon-button
                            [matMenuTriggerFor]="smenu"
                            aria-label="Example icon-button with a menu"
                          >
                            <mat-icon>more_vert</mat-icon>
                          </button>
                          <mat-menu #smenu="matMenu">
                            <button
                              mat-menu-item
                              color="primary"
                              class="col-md-12"
                              (click)="OnEditNewChanges(row)"
                            >
                              Edit
                            </button>

                            <button
                              mat-menu-item
                              color="danger"
                              class="col-md-12"
                              (click)="OnDeleteChanges(row)"
                            >
                              Delete
                            </button>
                          </mat-menu>
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="tblReceivingID">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          Receiving #
                        </th>
                        <td mat-cell *matCellDef="let row">
                          {{ row.tblReceivingID }}
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="tblCompanyChargesID">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          Company Charges#
                        </th>
                        <td mat-cell *matCellDef="let row">
                          {{ row.tblCompanyChargesID }}
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="tblInvoiceListDescription">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          Invoice List Description
                        </th>
                        <td mat-cell *matCellDef="let row">
                          {{ row.tblInvoiceListDescription }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="ChargeDescription">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          Charge Description
                        </th>
                        <td mat-cell *matCellDef="let row">
                          {{ row.ChargeDescription }}
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="UnitPrice">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          Unit Price
                        </th>
                        <td mat-cell *matCellDef="let row">
                          {{ row.UnitPrice }}
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="Quantity">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          Quantity
                        </th>
                        <td mat-cell *matCellDef="let row">
                          {{ row.Quantity }}
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="Total">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          Total
                        </th>
                        <td mat-cell *matCellDef="let row">{{ row.Total }}</td>
                      </ng-container>
                      <ng-container matColumnDef="QBIntegrated">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                          QB Integrated
                        </th>
                        <td mat-cell *matCellDef="let row">
                          {{ row.QBIntegrated }}
                        </td>
                      </ng-container>
                      <tr
                        mat-header-row
                        *matHeaderRowDef="
							  displayedColumnsSearchdataSourceChangesReceivig
							"
                      ></tr>
                      <tr
                        mat-row
                        *matRowDef="
							  let row;
							  columns: displayedColumnsSearchdataSourceChangesReceivig
							"
                      ></tr>

                      <!-- Row shown when there is no matching data. -->
                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">
                          No data matching the filter "{{
                          inputChangeReceiving.value }}"
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>

                <mat-paginator
                  matPaginator
                  #TableSearchChangeReceivinngPaginator="matPaginator"
                  [pageSizeOptions]="[50, 100, 250, 1000]"
                  aria-label="Select page of users"
                  [pageSize]="50"
                ></mat-paginator>
              </div>
              <div style="margin-top: 5px"  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row">
               <h1>Invoice charges</h1>
                <table class="table table-success table-striped-columns">
                   <thead>
                   <tr>
                   
                   
                    <th>Description</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Total</th>
                    
                   </tr>
                   </thead>
                   <tbody>
                    <tr *ngFor="let item of arrayDatosChangeReceivinng2">
                        
                            
                        <td>{{item.tblInvoiceListDescription}}</td>
                        <td>{{item.UnitPrice}}</td>
                        <td>{{item.Quantity}}</td>
                        <td>{{item.Total}}</td>
            
                    </tr>
                   </tbody>
                  </table>
            
            </div>
            </div>
          </div>
          <div
          *ngIf="Registro"
          class="
            center
            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
          "
          style="margin-top: 6vh"
        >
          <ngx-file-drop
            dropZoneLabel="Drop files here"
            (onFileDrop)="dropped2($event)"
            (onFileOver)="fileOver2($event)"
            (onFileLeave)="fileLeave2($event)"
          >
            <ng-template
              ngx-file-drop-content-tmp
              let-openFileSelector="openFileSelector"
            >
              <div
                class="
                  col-xs-12
                  col-sm-12
                  col-md-12
                  col-lg-12
                  col-xl-12
                  col-xxl-12
                  row
                "
              >
                <button
                  type="button"
                  (click)="openFileSelector()"
                  mat-raised-button
                  color="primary"
                  class="
                    col-xs-12
                    col-sm-12
                    col-md-12
                    col-lg-12
                    col-xl-12
                    col-xxl-12
                  "
                >
                  Browse Files
                </button>

                <P
                  style="text-align: center; top: 2vh"
                  class="
                    col-xs-12
                    col-sm-12
                    col-md-12
                    col-lg-12
                    col-xl-12
                    col-xxl-12
                  "
                >
                  Upload Document Import Products</P
                >
              </div>
            </ng-template>
          </ngx-file-drop>
        </div>


        </div>
      </div>
    </mat-tab>
    <mat-tab label="Confirm receiving" [disabled]="confirmarTab">
      <button
        mat-raised-button
        color="primary"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        (click)="OnCancelTabas()"
      >
        Back
      </button>

      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
        style="margin-top: 30px"
      >
        <mat-form-field appearance="outline">
          <mat-label>Search</mat-label>
          <input
            matInput
            (keyup)="applyFilterTableConfirmacion($event)"
            placeholder="Search"
            #inputConfirmarProducto
          />
          <button
            mat-button
            (click)="openDialogLectorGeneral(4)"
            matSuffix
            mat-icon-button
            color="primary"
            aria-label="Example icon button with a menu icon"
          >
            <mat-icon>qr_code_scanner</mat-icon>
          </button>
          <mat-hint>Filter table</mat-hint>
        </mat-form-field>
        <div
          class="
            example-container
            mat-elevation-z8
            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
          "
        >
          <div
            class="
              example-loading-shade
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            "
            *ngIf="isLoadingResultsConfirm || isRateLimitReachedConfirm"
          >
            <mat-spinner *ngIf="isLoadingResultsConfirm" #spinner2></mat-spinner>
            <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
              No results found
            </div>
          </div>

          <div class="example-table-container">
            <button
              mat-raised-button
              color="success"
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
              (click)="OpenDialogMasivo()"
            >
              Confirm selected products
            </button>
            <table
              mat-table
              [dataSource]="dataConfirm"
              class="example-table"
              matSort
              matSortActive="created"
              matSortDisableClear
              matSortDirection="desc"
              #sortConfirm="matSort"
            >
              <!-- Checkbox Column -->
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <p>Select_all</p>
                  <mat-checkbox
                    (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                    [aria-label]="checkboxLabel()"
                  >
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox
                    (click)="OnMAsivoConfimacion(row, $event)"
                    (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)"
                    [aria-label]="checkboxLabel(row)"
                  >
                  </mat-checkbox>
                </td>
              </ng-container>
              <!-- Number Column -->
              <ng-container matColumnDef="id" sticky>
                <th mat-header-cell *matHeaderCellDef>Optiones</th>
                <td mat-cell *matCellDef="let row">
                  <button
                    mat-raised-button
                    style="width: 80px"
                    color="danger"
                    (click)="OnDeleteConfirmProductSearch(row)"
                  >
                    Delete
                  </button>
                </td>
              </ng-container>

              <!-- ItemNumber Column -->
              <ng-container matColumnDef="ItemNumber">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="theadTable">Item number</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.ItemNumber }}</div>
                </td>
              </ng-container>

              <!-- ItemDescription Column -->
              <ng-container matColumnDef="ItemDescription">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="theadTable">Description</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.staItemDescriptionte }}</div>
                </td>
              </ng-container>

              <!-- LotNumber Column -->
              <ng-container matColumnDef="LotNumber">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                  <div class="theadTable">Lot #</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.LotNumber }}</div>
                </td>
              </ng-container>
              <!-- StatedQuantity Column -->
              <ng-container matColumnDef="StatedQuantity">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                  Quantity
                </th>
                <td mat-cell *matCellDef="let row">
                  {{ row.StatedQuantity }}
                </td>
              </ng-container>
              <!-- Location Column -->
              <ng-container matColumnDef="Location">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                  <div class="theadTable">Location</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.Location }}</div>
                </td>
              </ng-container>
              <!-- LocationID Column -->
              <ng-container matColumnDef="LocationID">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                  <div class="theadTable">Location #</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.LocationID }}</div>
                </td>
              </ng-container>
              <!-- SerialNumber Column -->
              <ng-container matColumnDef="SerialNumber">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                  <div class="theadTable">Serial #</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.SerialNumber }}</div>
                </td>
              </ng-container>

              <!-- ExpirationDate Column -->
              <ng-container matColumnDef="Notas">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                  Notes
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-form-field
                    class="
                      example-full-width
                      col-xs-12
                      col-sm-12
                      col-md-12
                      col-lg-12
                      col-xl-12
                      col-xxl-12
                    "
                  >
                    <mat-label>
                      <span class="material-icons"> textsms </span>
                    </mat-label>
                    <input
                      matInput
                      #message
                      maxlength="256"
                      placeholder="Add notes"
                      [value]="row.Notes"
                    />
                    <mat-hint align="start"
                      ><strong>Don't disclose info</strong>
                    </mat-hint>
                    <mat-hint align="end"
                      >{{ message.value.length }} / 256</mat-hint
                    >
                  </mat-form-field>
                </td>
                <!-- ExpirationDate Column -->
              </ng-container>
              <ng-container matColumnDef="PalletAmount">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                  <div class="theadTable">Pallet amount</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.PalletAmount }}</div>
                </td>
              </ng-container>
              <!-- ItemValue Column -->
              <ng-container matColumnDef="ItemValue">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                  Value
                </th>
                <td mat-cell *matCellDef="let row">{{ row.ItemValue }}</td>
              </ng-container>
              <ng-container matColumnDef="productID" stickyEnd>
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                  <div class="theadTable">Product #</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.productID }}</div>
                </td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumnsConfirm"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumnsConfirm"
                (click)="selection.toggle(row)"
              ></tr>
              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                  No data matching the filter "{{ inputConfirmarProducto.value
                  }}"
                </td>
              </tr>
            </table>
          </div>
        </div>
        <mat-paginator
          [length]="resultsLengthConfirm"
          [pageSizeOptions]="[5, 10, 25, 100, 1000,7000]"
          [pageSize]="7000"
          #paginatorConfirm="matPaginator"
        ></mat-paginator>
      </div>
    </mat-tab>
    <mat-tab label="View received products" [disabled]="ViewProductTab">
      <button
        mat-raised-button
        color="primary"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        (click)="OnCancelTabas()"
      >
        Back
      </button>
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        style="margin-top: 30px"
      >
        <mat-form-field appearance="outline">
          <mat-label>Search</mat-label>
          <input
            matInput
            (keyup)="applyFilterViewProducts($event)"
            placeholder="Search filter"
            #inputSearchViewProducts
          />
          <button
            mat-button
            (click)="openDialogLectorGeneral(3)"
            matSuffix
            mat-icon-button
            color="primary"
            aria-label="Example icon button with a menu icon"
          >
            <mat-icon>qr_code_scanner</mat-icon>
          </button>
          <mat-hint>Filter table</mat-hint>
        </mat-form-field>
        <div
          class="
            example-container
            mat-elevation-z8
            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
          "
        >
          <div class="example-table-container">
            <table
              mat-table
              [dataSource]="dataServicesViewProducts"
              matSort
              #TableViewReceivingProductsSort="matSort"
            >
              <ng-container matColumnDef="id" sticky>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Options
                </th>
                <td mat-cell *matCellDef="let row">
                  <button
                    mat-raised-button
                    style="width: 80px"
                    color="primary"
                    (click)="openDialogEditProductsItems(row)"
                  >
                    Edit
                  </button>
                  <button
                    mat-raised-button
                    style="width: 80px"
                    color="danger"
                    (click)="OnDeleteViewProdts(row)"
                  >
                    Delete
                  </button>

                  <button
                    *ngIf="false"
                    mat-menu-item
                    style="width: 200px; height: 43px"
                    (click)="openDialogPalletEdit(row)"
                  >
                    <span> Change customer </span>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="tblReceivingProductsID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <div class="theadTable">Receiving Products #</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <ngx-barcode
                    [bc-value]="row.tblReceivingProductsID"
                    [bc-display-value]="true"
                    bc-format="CODE39"
                  >
                  </ngx-barcode>
                </td>
              </ng-container>
              <ng-container matColumnDef="tblProductID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <div class="theadTable">Products #</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <ngx-barcode
                    [bc-value]="row.tblProductID"
                    [bc-display-value]="true"
                    bc-format="CODE39"
                  ></ngx-barcode>
                </td>
              </ng-container>
              <ng-container matColumnDef="LotNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <div class="theadTable">Lot number</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <ngx-barcode
                    [bc-value]="row.LotNumber"
                    [bc-display-value]="true"
                    bc-format="CODE39"
                  ></ngx-barcode>
                </td>
              </ng-container>
              <ng-container matColumnDef="StatedQuantity">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <div class="theadTable">Stated quantity</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.StatedQuantity }}</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="ActualQuantity">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <div class="theadTable">Actual quantity</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.ActualQuantity }}</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="Discrepancy">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Discrepancy
                </th>
                <td mat-cell *matCellDef="let row">{{ row.Discrepancy }}</td>
              </ng-container>
              <ng-container matColumnDef="AvailableQuantity">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <div class="theadTable">Available quantity</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.AvailableQuantity }}</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="tblLocationID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <div class="theadTable">Location #</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <ngx-barcode
                    [bc-value]="row.tblLocationID"
                    [bc-display-value]="true"
                    bc-format="CODE39"
                  >
                  </ngx-barcode>
                </td>
              </ng-container>
              <ng-container matColumnDef="ExpirationDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <div class="theadTable">Exp. Date</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.ExpirationDate }}</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="SerialNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <div class="theadTable">Serial #</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <ngx-barcode
                    [bc-value]="row.SerialNumber"
                    [bc-display-value]="true"
                    bc-format="CODE39"
                  ></ngx-barcode>
                </td>
              </ng-container>
              <ng-container matColumnDef="Completed">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Completed
                </th>
                <td mat-cell *matCellDef="let row">{{ row.Completed }}</td>
              </ng-container>
              <ng-container matColumnDef="Notes">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Notes</th>
                <td mat-cell *matCellDef="let row">{{ row.Notes }}</td>
              </ng-container>
              <ng-container matColumnDef="DateCreated">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <div class="theadTable">Date created</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.DateCreated }}</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="ItemNumber" stickyEnd>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Item number
                </th>
                <td mat-cell *matCellDef="let row">
                  <ngx-barcode
                    [bc-value]="row.ItemNumber"
                    [bc-display-value]="true"
                    bc-format="CODE39"
                  ></ngx-barcode>
                </td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="ColumnsServicesViewProducts"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: ColumnsServicesViewProducts"
              ></tr>

              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                  No data matching the filter "{{ inputSearchViewProducts.value
                  }}"
                </td>
              </tr>
            </table>
          </div>
        </div>

        <mat-paginator
          [pageSizeOptions]="[5, 10, 25, 100]"
          #TableViewReceivingProductsPaginator="matPaginator"
        >
        </mat-paginator>
      </div>
    </mat-tab>
    <mat-tab label="Search receiving">
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
        style="margin-top: 17px"
      >
        <h3
          *ngIf="false"
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          style="text-align: center; margin-bottom: 25px; margin-top: 25px"
        >
          Search receiving
        </h3>

        <div
          class="
            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            row
          "
        >
          <div
            class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 InputSty"
            style="margin-top: 14px"
          >
            <mat-form-field class="example-form-field InputSty">
              <mat-label>Search receivings</mat-label>
              <input matInput type="text" [(ngModel)]="value"  class="TabOnEnter" tabindex="1"/>
              <button
                mat-button
                *ngIf="value"
                matSuffix
                mat-icon-button
                aria-label="Search"
                (click)="value = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div
            class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
          >
            <mat-form-field color="accent" appearance="fill" class="InputSty">
              <mat-label>From</mat-label>
              <input matInput [matDatepicker]="picker1" [(ngModel)]="From" class="TabOnEnter" tabindex="2"/>
              <mat-datepicker-toggle
                matSuffix
                [for]="picker1"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
          </div>

          <div
            class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
          >
            <mat-form-field color="accent" appearance="fill" class="InputSty">
              <mat-label>To</mat-label>
              <input matInput [matDatepicker]="picker2" [(ngModel)]="To" tabindex="3" class="TabOnEnter"/>
              <mat-datepicker-toggle
                matSuffix
                [for]="picker2"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker2 color="primary"></mat-datepicker>
            </mat-form-field>
          </div>
          <div
            class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
            style="margin-top: 14px"
          >
            <mat-checkbox class="example-margin InputSty TabOnEnter" [(ngModel)]="checked" tabindex="4"
              >Completed ?</mat-checkbox
            >
          </div>
          <div
            class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 InputSty row"
          >
            <button
              class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 col-xxl-5 InputSty TabOnEnter"
              type="button"
              mat-raised-button
              color="primary"
              style="width: 150px; height: 43px"
              (click)="OnChangeSearch()"
              tabindex="-1"
            >
              Search
            </button>
          </div>
        </div>

        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          *ngIf="searchTable"
        >
          <mat-form-field appearance="outline">
            <mat-label>Search</mat-label>
            <input
              matInput
              (keyup)="applyFilterSearch($event)"
              placeholder="Search"
              #dataSearch
            />
            <button
              mat-button
              matSuffix
              mat-icon-button
              color="primary"
              (click)="openDialogLector()"
              aria-label="Example icon button with a menu icon"
            >
              <mat-icon>qr_code_scanner</mat-icon>
            </button>
            <mat-hint>Filter table</mat-hint>
          </mat-form-field>
          <div
            class="
              example-container
              mat-elevation-z8
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            "
          >
            <button
              mat-button
              matSuffix
              mat-icon-button
              color="success"
              (click)="exportAsExcel()"
              aria-label="Example icon button with a menu icon"
              class="col-md-12"
            >
              Excel

              <mat-icon>cloud_download</mat-icon>
            </button>
            <div
              class="example-loading-shade"
              *ngIf="isLoadingResults || isRateLimitReached"
            >
              <mat-spinner *ngIf="isLoadingResults" #spinner3></mat-spinner>
              <div
                class="example-rate-limit-reached"
                *ngIf="isRateLimitReached"
              >
                3plfreightsoftware Warehouse
              </div>
            </div>

            <div class="example-table-container" #exportExcel>
              <table
                mat-table
                [dataSource]="dataSourceSearch"
                class="example-table"
                matSort
                matSortDirection="desc"
                #TableSearchSort="matSort"
              >
                <!-- Created Column -->
                <ng-container matColumnDef="ID" sticky>
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    Options
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="mensu"
                      aria-label="Example icon-button with a menu"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #mensu="matMenu">
                      <button
                        mat-menu-item
                        style="width: 100px; height: 43px"
                        (click)="Oneditar(row)"
                      >
                        Edit
                      </button>
                      <button
                        mat-menu-item
                        color="success"
                        (click)="OnConfirmar(row)"
                        style="width: 100px; height: 43px"
                      >
                        Confirm
                      </button>

                      <button
                        mat-menu-item
                        color="danger"
                        style="width: 100px; height: 43px"
                        (click)="OnDeleteProductSearch(row)"
                      >
                        Delete
                      </button>
                      <button
                      mat-menu-item
                    
                      color="danger"
                        style="width: 200px; height: 43px"
                      (click)="onRemoveInventory(row)"
                    >
                      Remove Inventory
                    </button>
                      <button
                        mat-menu-item
                        color="warning"
                        style="width: 100px; height: 43px"
                        (click)="OpenDialogPDFpalletlabel(row)"
                      >
                        Pdf
                      </button>

                      <button
                        mat-menu-item
                        style="width: 200px; height: 43px"
                        (click)="openDialogPalletEdit(row)"
                      >
                        <span> Change customer </span>
                      </button>
                      <button
                      mat-menu-item
                      style="width: 200px; height: 43px"
                      (click)="openExportDataToShipping(row)"
                    >
                      <span> Export to shipping </span>
                    </button>
                    </mat-menu>
                  </td>
                </ng-container>
                <!-- Created Column -->
                <ng-container matColumnDef="idReference">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    #
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.ID }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="Company_Name">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    <div class="theadTable">Company name</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">
                      {{ row.Company_Name }}
                    </div>
                  </td>
                </ng-container>

                <!-- Created Column -->
                <ng-container matColumnDef="tblcustomerID">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    <div class="theadTable">Customer #</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">
                      {{ row.tblcustomerID }}
                    </div>
                  </td>
                </ng-container>
                <!-- Number Column -->
                <ng-container matColumnDef="ReferenceNumber">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Reference #</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.ReferenceNumber }}</div>
                  </td>
                </ng-container>

                <!-- Title Column -->
                <ng-container matColumnDef="PONumber">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    <div class="theadTable">PO #</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.PONumber }}</div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="ReceivedDate">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Received Date</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.ReceivedDate }}</div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="ETA">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">ETA</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.ETA }}</div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="status_type">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    Status
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.status_type }}
                  </td>
                </ng-container>
                <!-- Created Column -->
                <ng-container matColumnDef="ContainerNumber">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    <div class="theadTable">Container #</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.ContainerNumber }}</div>
                  </td>
                </ng-container>
                <!-- State Column -->
                <ng-container matColumnDef="CapacityType">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Capacity type</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.CapacityType }}</div>
                  </td>
                </ng-container>

                <!-- Created Column -->
                <ng-container matColumnDef="BOLNumber">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    <div class="theadTable">BOL #</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.BOLNumber }}</div>
                  </td>
                </ng-container>
               
                

                <!-- Created Column -->
                <ng-container matColumnDef="charges" stickyEnd>
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    Charges
                  </th>
                  <td mat-cell *matCellDef="let row">{{ row.charges }}</td>
                </ng-container>
                <!-- Created Column -->
                <ng-container matColumnDef="Billed">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    Billed
                  </th>
                  <td mat-cell *matCellDef="let row">{{ row.Billed }}</td>
                </ng-container>
                <!-- Created Column -->
                <ng-container matColumnDef="AllChargesAdded">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    All Charges Added
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.AllChargesAdded }}
                  </td>
                </ng-container>
                <!-- Created Column -->
                <ng-container matColumnDef="HandlingCharge">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    Handling Charge
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.HandlingCharge }}
                  </td>
                </ng-container>
                <!-- Created Column -->
              
                <!-- Created Column -->
                <ng-container matColumnDef="ShortTermStorage" stickyEnd>
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    Short Term Storage
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.ShortTermStorage }}
                  </td>
                </ng-container>
                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumnsSearch"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsSearch"
                ></tr>
              </table>
            </div>
          </div>
          <mat-paginator
            [length]="resultsLength"
            #TableSearchPaginator="matPaginator"
            [pageSizeOptions]="[50, 100, 250, 1000]"
            [pageSize]="50"
          ></mat-paginator>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Inventory available" *ngIf="false">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <mat-form-field appearance="fill">
            <mat-label>Select customer</mat-label>
            <mat-select
              (selectionChange)="OnChangeInventoryAvailable($event.value)"
            >
              <mat-option
                *ngFor="let item of PlaceOrderCustomer"
                [value]="item.key"
                >{{ item.value }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          *ngIf="InventarioTable"
        >
          <mat-form-field appearance="outline">
            <mat-label>Search</mat-label>
            <input
              matInput
              (keyup)="applyFilter($event)"
              placeholder="Search"
              #input
            />
            <button
              mat-button
              (click)="openDialogLectorGeneral(2)"
              matSuffix
              mat-icon-button
              color="primary"
              aria-label="Example icon button with a menu icon"
            >
              <mat-icon>qr_code_scanner</mat-icon>
            </button>
            <mat-hint>Filter table</mat-hint>
          </mat-form-field>
          <div
            class="
              example-container
              mat-elevation-z8
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            "
          >
            <div class="example-table-container">
              <table
                mat-table
                [dataSource]="dataSource"
                matSort
                #TableReceiveSort="matSort"
                class="example-table"
              >
                <!-- ID Column -->
                <ng-container matColumnDef="rowNumber" sticky>
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
                  <td mat-cell *matCellDef="let row">{{ row.rowNumber }}</td>
                </ng-container>

                <!-- ItemNumber Column -->
                <ng-container matColumnDef="ItemNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <div class="theadTable">Item number</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <ngx-barcode
                      [bc-value]="row.ItemNumber"
                      [bc-display-value]="true"
                      bc-format="CODE39"
                    ></ngx-barcode>
                  </td>
                </ng-container>

                <!-- Description Column -->
                <ng-container matColumnDef="Description">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Description
                  </th>
                  <td mat-cell *matCellDef="let row">{{ row.Description }}</td>
                </ng-container>

                <!-- Received Column -->
                <ng-container matColumnDef="Received">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Received
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.Received }}
                  </td>
                </ng-container>
                <!-- Pending Column -->
                <ng-container matColumnDef="Pending">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Pending
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.Pending }}
                  </td>
                </ng-container>
                <!-- Shipped Column -->
                <ng-container matColumnDef="Shipped">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Shipped
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.Shipped }}
                  </td>
                </ng-container>
                <!-- Available Column -->
                <ng-container matColumnDef="Available">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Available
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.Available }}
                  </td>
                </ng-container>
                <!-- Cartons Column -->
                <ng-container matColumnDef="Cartons">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Cartons
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.Cartons }}
                  </td>
                </ng-container>
                <!-- Pallets Column -->
                <ng-container matColumnDef="Pallets" stickyEnd>
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Pallets
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.Pallets }}
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">
                    No data matching the filter "{{ input.value }}"
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <mat-paginator
            [pageSizeOptions]="[5, 10, 25, 100]"
            #TableReceivePaginator="matPaginator"
          ></mat-paginator>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Move inventory">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <mat-form-field
            class="
              col-xs-11 col-sm-11 col-md-11 col-lg-11 col-xl-11 col-xxl-112
            "
          >
            <mat-label>Customer</mat-label>
            <mat-select
              (selectionChange)="OnCChangeInventoryMove($event.value)"
            >
              <mat-option
                *ngFor="let opt of PlaceOrderCustomer"
                [value]="opt.key"
              >
                {{ opt.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          *ngIf="MoveInventoryTable"
        >
          <mat-form-field appearance="outline">
            <mat-label>Search</mat-label>
            <input
              matInput
              (keyup)="applyFilterMove($event)"
              placeholder="Search"
              #input2
            />
            <button
              mat-button
              (click)="openDialogLectorGeneral(1)"
              matSuffix
              mat-icon-button
              color="primary"
              aria-label="Example icon button with a menu icon"
            >
              <mat-icon>qr_code_scanner</mat-icon>
            </button>
            <mat-hint>Filter table</mat-hint>
          </mat-form-field>

          <div
            class="
              example-container
              mat-elevation-z8
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            "
          >
            <div class="example-table-container">
              <table
                mat-table
                matSort
                [dataSource]="dataSourceMove"
                #TableTwoSort="matSort"
                class="example-table"
              >
                <!-- ID Column -->
                <ng-container matColumnDef="id" sticky>
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Options
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <button
                      mat-raised-button
                      color="primary"
                      (click)="openDialogEditMoveInventory(row)"
                    >
                      Move
                    </button>
                  </td>
                </ng-container>

                <!-- ItemNumber Column -->
                <ng-container matColumnDef="ItemNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <div class="theadTable">Item number</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.ItemNumber }}</div>
                  </td>
                </ng-container>
                <!-- Description Column -->
                <ng-container matColumnDef="Description">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Description
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.Description }}</div>
                  </td>
                </ng-container>
                <!-- LotNumber Column -->
                <ng-container matColumnDef="LotNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <div class="theadTable">Lot #</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.LotNumber }}</div>
                  </td>
                </ng-container>
                <!-- Location Column -->
                <ng-container matColumnDef="Location">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Location
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.Location }}</div>
                  </td>
                </ng-container>
                <!-- Quantity Column -->
                <ng-container matColumnDef="Quantity" stickyEnd>
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Quantity
                  </th>
                  <td mat-cell *matCellDef="let row">{{ row.Quantity }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsMove"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsMove"
                ></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">
                    No data matching the filter "{{ input2.value }}"
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <mat-paginator
            #TableTwoPaginator="matPaginator"
            [pageSizeOptions]="[5, 10, 25, 100]"
          ></mat-paginator>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0.07)"
  size="medium"
  color="#2879ff"
  type="square-jelly-box"
  [fullScreen]="true"
>
</ngx-spinner>
